<h2 mat-dialog-title>
  @if (accessGroupId) {
    <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
    Rediger adgangsgruppe
  }
  @if (!accessGroupId) {
    <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
    Opret adgangsgruppe
  }
</h2>
<button class="btn-close btn-icon" mat-dialog-close>
  <mat-icon class="material-icons">close</mat-icon>
</button>

@if (accessGroupForm) {
  <form [formGroup]="accessGroupForm">
    <mat-dialog-content>
      <div class="form-row">
        <mat-form-field>
          <mat-label>Navn</mat-label>
          <input type="text" matInput formControlName="name" />
          @if (name.hasError('required')) {
            <mat-error>
              <div>Indtast venligst et navn på adgangsgruppen</div>
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div class="form-row" [class.not-allowed]="accessGroupId">
        <mat-form-field class="actions__status" [class.disabled-and-muted]="accessGroupId">
          <mat-label>Vælg biltype</mat-label>
          <mat-select formControlName="carType" okCustomDropDownArrowDirective>
            @for (cartype of carTypes | enumToArray | translateAccessGroupCarTypeEnum; track cartype.index) {
              <mat-option [value]="cartype.index">
                {{ cartype.name }}
              </mat-option>
            }
          </mat-select>
          <mat-icon matSuffix></mat-icon>
          @if (accessGroupId) {
            <mat-hint class="text-warning warning-text"> Der kan ikke ændres biltype på en eksisterende adgangsgruppe </mat-hint>
          }
        </mat-form-field>
      </div>
      <div class="form-row" [class.not-allowed]="accessGroupId">
        <adm-org-typeahead
          [disabled]="accessGroupId ? true : false"
          [initialId]="accessGroupForm.controls.organizationId.value ?? undefined"
          [resetTrigger]="resetOrgTrigger()"
          (clearTypeAhead)="clearOrganizationSelector()"
          (itemSelected)="organizationSelected($event ?? undefined)" />
      </div>
      <div class="form-row">
        <mat-slide-toggle formControlName="showDiscountFields" color="primary">Rabat</mat-slide-toggle>
      </div>
      @if (accessGroupForm.get('showDiscountFields')?.value) {
        <div class="form-row">
          <mat-form-field class="actions__shared-discount">
            <mat-label>Tværgående rabat</mat-label>
            <mat-select formControlName="sharedDiscountIdentifier" okCustomDropDownArrowDirective>
              <mat-option [value]="null">Ingen</mat-option>
              @for (discount of sharedDiscounts; track discount.identifier) {
                <mat-option [value]="discount.identifier">
                  {{ discount.name }} ({{ discount.amount }} {{ discount.discount_type | translateOrganizationDiscountType }})
                </mat-option>
              }
            </mat-select>
            <mat-icon matSuffix></mat-icon>
          </mat-form-field>
        </div>
        <div class="form-row discount">
          <mat-form-field class="discount__amount">
            <mat-label>Rabat</mat-label>
            <input type="text" [inputMask]="priceInputMask" matInput formControlName="amount" />
            <mat-icon matSuffix></mat-icon>
            <mat-hint class="text-warning">Ekskl. moms</mat-hint>
            @if (amount.hasError('required')) {
              <mat-error>
                <div>Indtast venligst en rabat i kr. eller procent</div>
              </mat-error>
            }
            @if (amount.hasError('min') || amount.hasError('max')) {
              <mat-error>Værdi skal være 0-100 </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>Rabattype</mat-label>
            <mat-select formControlName="discountType" okCustomDropDownArrowDirective>
              @for (enum of discountTypes | keyvalue; track enum.key) {
                <mat-option [value]="enum.key">
                  {{ enum.key | translateOrganizationDiscountType }}
                </mat-option>
              }
            </mat-select>
            <mat-icon matSuffix></mat-icon>
            <mat-hint class="text-warning">Rabattype sættes på organisationen</mat-hint>
          </mat-form-field>
        </div>
      }
      <div class="form-row custom-selector-field" [class.disabled-and-muted]="!this.organizationId.value">
        <span class="custom-selector-field__row-label"> Ladepunkter </span>
        <button type="button" (click)="openConnectorSelector()" class="custom-selector-field__toggle">
          <mat-icon svgIcon="socket_type_ccs2"></mat-icon>
          <span class="custom-selector-field__input-label">Vælg ladepunkter</span>
          @if (connectorBadgeCount > 0) {
            <span class="custom-selector-field__chosen">
              <div matBadge="{{ connectorBadgeCount }}" matBadgeOverlap="false">Valgt</div>
            </span>
          }
          <mat-icon class="custom-selector-field__arrow" matSuffix>keyboard_arrow_down</mat-icon>
        </button>
        @if (connectorBadgeCount > 0) {
          <button class="custom-selector-field__clear-input" type="button" (click)="resetLocations()" aria-label="Ryd indhold i feltet">
            <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
          </button>
        }
      </div>

      @if (discountPreviews.length > 0) {
        <div class="form-row margin--top-m">
          <ok-feedback-info>
            <div>
              <div class="center-text icon-text-container">
                <b
                  >Brugere og kort i adgangsgruppen vil fremadrettet betale denne pris på de valgte ladepunkter (priser er inklusive
                  moms)</b
                >
              </div>
              <div class="table-container">
                <table class="table">
                  <thead>
                    <tr>
                      <th class="align-left">Prispolitik</th>
                      <th class="align-left" style="width: 150px">Pris før rabat</th>
                      <th class="align-left" style="width: 150px">Pris efter rabat</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (discountPreview of discountPreviews; track $index) {
                      <tr>
                        <td>{{ discountPreview.pricePolicyName }}</td>
                        <td class="price">{{ discountPreview.origPricePerUnit | number: '1.2-2' }} kr.</td>
                        <td class="price" [class.calculating]="calculating">
                          {{ discountPreview.discountedPricePerUnit | number: '1.2-2' }} kr.
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </ok-feedback-info>
        </div>
      }
    </mat-dialog-content>
  </form>
}

<mat-dialog-actions>
  @if (accessGroupId) {
    <div class="unit-identifier">
      <span>Adgangsgruppe ID:</span>
      {{ name.value }}
    </div>
  }
  <button mat-dialog-close type="button" mat-button>Annuller</button>
  <button
    class="actions__button margin--right-2"
    type="button"
    mat-raised-button
    color="primary"
    [disabled]="!accessGroupForm || !accessGroupForm.valid"
    (click)="saveAccessGroup()">
    Gem
  </button>
</mat-dialog-actions>
